import { h } from "@stencil/core";
/**
 * Render a `<select>` if `options` has values, else render `<input type="hidden">` with `selected` as the value.
 */
export class PossiblyHiddenSelect {
  constructor() {
    this.fieldLabel = undefined;
    this.name = undefined;
    this.selected = undefined;
    this.options = undefined;
    this.fieldLabel = "";
    this.name = "";
    this.selected = "";
    this.options = new Set();
  }
  render() {
    if (this.options.size <= 1) {
      return h("input", { name: this.name, type: "hidden", value: this.selected });
    }
    else {
      return (h("label", null, this.fieldLabel, h("select", { name: this.name, required: true }, [...this.options.entries()].map(([value, label]) => (h("option", { value: value, selected: this.selected === value }, label))))));
    }
  }
  static get is() { return "input-possibly-hidden-select"; }
  static get properties() {
    return {
      "fieldLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "field-label",
        "reflect": false
      },
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false
      },
      "selected": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected",
        "reflect": false
      },
      "options": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Map<string, string> | Set<string>",
          "resolved": "Map<string, string> | Set<string>",
          "references": {
            "Map": {
              "location": "global"
            },
            "Set": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
}
//# sourceMappingURL=input-possibly-hidden-select.js.map
